import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { firstValueFrom, Observable } from 'rxjs';
import { AllegatiArticoliService } from 'src/app/shared/services/allegati-articoli.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import ArrayStore from 'devextreme/data/array_store';
import {
  DxDataGridComponent,
  DxPopupComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import * as FileSaver from 'file-saver';
import { confirm } from 'devextreme/ui/dialog';
import { Articoli } from 'src/app/models/articoli';
import { AllegatiArticoli } from 'src/app/models/allegati-articoli';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
} from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-tabella-dpi',
  templateUrl: './tabella-dpi.component.html',
  imports: [
    DxPopupComponent,
    DxDataGridComponent,
    DxTemplateDirective,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoEditingComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxoLookupComponent,
  ],
  standalone: true,
})
export class TabellaDpiComponent {
  private articoliS = inject(ArticoliService);
  private allS = inject(AllegatiArticoliService);
  private ns = inject(NavigatorService);
  private tipiService = inject(TipiArticoliService);
  private sanitizer = inject(DomSanitizer);

  dataSource: any;
  articoliList: Observable<Articoli[]>;
  allegatiList: AllegatiArticoli[];
  listTipiArticoli: TipiArticoli[] = [];

  allegatiDpiDataSourceStorage: any;
  popupImageVisible = false;
  currentImage: SafeResourceUrl;

  collapsed = false;

  constructor() {
    this.allegatiDpiDataSourceStorage = [];
    this.allS.list().subscribe((dati) => {
      this.allegatiList = dati;
    });
    this.tipiService.getListTipiArticoliTemp().subscribe((dati) => {
      this.listTipiArticoli = dati;
    });
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.articoliS.list())
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        return firstValueFrom(this.articoliS.insert(values))
          .then((res) => {
            this.articoliS.listTemp(true).subscribe();
            return res;
          })
          .catch(() => {
            throw 'Insertion failed';
          });
      },
      remove: (values) => {
        console.log(values);
        return firstValueFrom(this.articoliS.remove(values))
          .then(() => {
            console.log('delete eseguito');
            this.articoliS.listTemp(true).subscribe();
          })
          .catch(() => {
            throw 'Deletion failed';
          });
      },
      update: (key, values) => {
        return firstValueFrom(this.articoliS.update(key, values))
          .then(() => {
            this.articoliS.listTemp(true).subscribe();
          })
          .catch(() => {
            throw 'Update failed';
          });
      },
    });
  }
  getAllegati(idDpi: number) {
    let item = this.allegatiDpiDataSourceStorage.find(
      (i: any) => i.idDpi === idDpi,
    );
    if (!item) {
      item = {
        idDpi: idDpi,
        dataSourceInstance: new DataSource({
          store: new ArrayStore({
            data: this.allegatiList,
            key: 'id',
          }),
          filter: ['idDpi', '=', idDpi],
        }),
      };
      this.allegatiDpiDataSourceStorage.push(item);
    }
    return item.dataSourceInstance;
  }

  scaricaFile(allegato: AllegatiArticoli) {
    this.allS.scarica(allegato.id).subscribe((res) => {
      FileSaver.saveAs(res, allegato.nomeFile);
    });
  }

  eliminaFile(allegato: AllegatiArticoli) {
    const result = confirm("<i>Vuoi eliminare l'allegato?</i>", 'Conferma');
    result.then((dialogResult) => {
      if (dialogResult) {
        this.allS.delete(allegato.id).subscribe(() => {
          console.log('Allegato eliminato');
          this.allS.list().subscribe((dati) => {
            this.allegatiList = dati;
            console.log(dati);
            this.allegatiDpiDataSourceStorage = [];
          });
        });
      }
    });
  }

  visualizzaFile(allegato: AllegatiArticoli) {
    this.allS.scarica(allegato.id).subscribe((res) => {
      const url = window.URL.createObjectURL(res);
      window.open(url);
    });
  }

  visualizzaImmagine(allegato: AllegatiArticoli) {
    this.allS.getImmagine(allegato.id).subscribe((res) => {
      this.currentImage = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image;base64,' + res,
      );
      this.popupImageVisible = true;
    });
  }

  goToAllega(idDpi: number) {
    this.ns.goToAllega(idDpi);
  }

  endsWith(str: any, suffix: any) {
    if (str == undefined) {
      return false;
    }
    return (
      str
        .toUpperCase()
        .indexOf(suffix.toUpperCase(), str.length - suffix.length) !== -1
    );
  }
}
